import { render, staticRenderFns } from "./DataTable2.vue?vue&type=template&id=978a6c40&scoped=true"
import script from "./DataTable2.vue?vue&type=script&lang=js"
export * from "./DataTable2.vue?vue&type=script&lang=js"
import style0 from "./DataTable2.vue?vue&type=style&index=0&id=978a6c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978a6c40",
  null
  
)

export default component.exports